<template>
  <div>
    <v-row no-gutters>
      <span class="textLight--text font-weight-medium text-h5 text-start">
        {{
          isPublicProfile
            ? $t("user.profile.profile")
            : $t("user.profile.myProfile")
        }}
      </span>
    </v-row>

    <v-row>
      <v-col cols="12" :lg="vertical || isPublicProfile ? '12' : '6'">
        <profile-card @onError="this.$emit('onError')" />
      </v-col>

      <v-col v-if="!isPublicProfile" cols="12" :lg="vertical ? '12' : '6'">
        <profile-progress-card :showGraph="showGraph" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ProfileCard from "../ProfileCard.vue";
import ProfileProgressCard from "../ProfileProgressCard.vue";

export default {
  components: {
    ProfileCard,
    ProfileProgressCard,
  },
  props: {
    showGraph: {
      type: Boolean,
      default: true,
    },
    vertical: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      organizations: [],
    };
  },
  computed: {
    isPublicProfile() {
      return this.$route.name === "PublicProfile";
    },
  },
};
</script>
